import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { PickingVm } from './picking.vm';

export class GetPickingsVm extends PageResponseVm<PickingVm, string> {
    @IsString()
    nextOffset: string;

    @Type(() => PickingVm)
    @ValidateNested({ each: true })
    objects: PickingVm[];
}
